module.exports = __webpack_public_path__ + "static/media/sub_com_courtroom.43e599fc.jpg";